import React from 'react';
import PropTypes from 'prop-types';
import { ShowMCQList } from '../shared';
import { getGCSUrl } from '../../../../services/Common';
import './TechLead.model.css';
import NavigateNextSharpIcon from '@material-ui/icons/NavigateNextSharp';
import { PageConstant } from '../../../../constants';
const { Modal } = require('antd');
const TechLeadModel = ({ visible, onCancel, techLeadStack, personalInfo, oneTestLeft }) => {
  let MCQList = (techLeadStack && techLeadStack.MCQList) || [];
  MCQList = MCQList.filter((item) => !item.submit_time || !oneTestLeft);

  if (!location.href.includes(PageConstant.MCQ_LIST)) {
    return null;
  }

  return (<Modal visible={visible} onCancel={onCancel} footer={null}
    destroyOnClose
    className='turing-ui-v2-techlead-modal'
    centered >
    <div>
      <div className='material-icons  turing-ui-v2-techlead-modal-congratulation-icon'>
      </div>
      {oneTestLeft ? (
        <div className='turing-ui-v2-techlead-modal-congratulation-text'>
            You only have one test left!
          <div> Complete the Team Lead stack now</div>
        </div>
      ) : (
        <div className='turing-ui-v2-techlead-modal-congratulation-text'>
            Congratulations,  {personalInfo && personalInfo.full_name}!
          <div> Complete the Team Lead stack now</div>
        </div>
      )}
      <div className='turing-ui-v2-techlead-modal-pluspoint'>
      As a team lead you will be offered a higher pay than most Turing engineers (Who already earn higher salaries than comparable roles in their countries)
      </div>
      <div >
        <ShowMCQList workExpCompleted dataSource={MCQList} className={'turing-ui-v2-techlead-tests-list-container'}>
          {(item) => (
            <div key={item.challenge_id} className={'turing-ui-v2-techlead-tests-list'} onClick={() => item.start()}>
              <div>
                <img className='turing-ui-v2-techlead-tests-list-testicon' src={`${getGCSUrl()}/icon/${item.icon}`} width="30px" height="30px"/>
              </div>
              <div>
                <div className={'turing-ui-v2-techlead-tests-list-challenge-name'}>
                  <p>{item.challenge_name}</p>
                  <div className='turing-ui-v2-techlead-tests-list-challenge-name-duration'>{`${item.challenge_duration} min`}</div>
                </div>
              </div>
              <div className='turing-ui-v2-techlead-tests-list-challenge-next'>
                <NavigateNextSharpIcon />
              </div>

            </div>
          )}
        </ShowMCQList>
      </div>

    </div>

  </Modal>);
};

TechLeadModel.propTypes = {
  visible: PropTypes.bool,
  oneTestLeft: PropTypes.bool,
  techLeadStack: PropTypes.any,
  onCancel: PropTypes.func,
  personalInfo: PropTypes.object
};

export default TechLeadModel;
